import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { OrgEmailNotifications, OrgGeneralNotifications } from 'models/organization';

type LabNotificationSettingTableProps = {
    generalNotifications: OrgGeneralNotifications;
    emailNotifications: OrgEmailNotifications;
    handleGeneralNotifications: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleEmailNotifications: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
const LabNotificationSettingTable: FC<LabNotificationSettingTableProps> = ({
    generalNotifications,
    emailNotifications,
    handleGeneralNotifications,
    handleEmailNotifications,
}: LabNotificationSettingTableProps) => {
    const { t: translate } = useTranslation(['lab-settings']);

    return (
        <Box mb={4}>
            {/* DD-3492: named apart from the orders this lab placed with partner labs. */}
            <Typography variant="h3">{translate('lab-settings:RECEIVED_ORDER_NOTIFICATIONS')}</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width="60%">{translate('lab-settings:NOTIFICATION')}</TableCell>
                            <TableCell>{translate('lab-settings:IN_APPLICATION')}</TableCell>
                            <TableCell>{translate('common:EMAIL')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{translate('lab-settings:NEW_ORDER_RECEIVED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={generalNotifications.newOrder}
                                    onChange={handleGeneralNotifications}
                                    name="newOrder"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={emailNotifications.newOrder}
                                    onChange={handleEmailNotifications}
                                    name="newOrder"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:MESSAGE_RECEIVED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={generalNotifications.newMessage}
                                    onChange={handleGeneralNotifications}
                                    name="newMessage"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={emailNotifications.newMessage}
                                    onChange={handleEmailNotifications}
                                    name="newMessage"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_MODIFIED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={generalNotifications.orderModified}
                                    onChange={handleGeneralNotifications}
                                    name="orderModified"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={emailNotifications.orderModified}
                                    onChange={handleEmailNotifications}
                                    name="orderModified"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_RESENT')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={generalNotifications.orderResend}
                                    onChange={handleGeneralNotifications}
                                    name="orderResend"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={emailNotifications.orderResend}
                                    onChange={handleEmailNotifications}
                                    name="orderResend"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_CANCELED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={generalNotifications.orderCancelled}
                                    onChange={handleGeneralNotifications}
                                    name="orderCancelled"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={emailNotifications.orderCancelled}
                                    onChange={handleEmailNotifications}
                                    name="orderCancelled"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_RATED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={generalNotifications.orderRated}
                                    onChange={handleGeneralNotifications}
                                    name="orderRated"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={emailNotifications.orderRated}
                                    onChange={handleEmailNotifications}
                                    name="orderRated"
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default LabNotificationSettingTable;
